import { Link } from "react-router-dom";
import { useI18n } from "../../i18n";

// Language-aware internal link. Automatically prefixes the active language.
export default function LangLink({ to, children, className, ...rest }) {
  const { langPath } = useI18n();
  return (
    <Link to={langPath(to)} className={className} {...rest}>
      {children}
    </Link>
  );
}
